import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile';
import React from 'react';
import * as Sentry from '@sentry/react';
import { CloudflareActionProps } from './CloudflareUtils';

export function CloudflareTurnstileWidget({
  type,
  onValidationChange,
}: CloudflareActionProps & {
  onValidationChange?: (isValid: boolean) => void;
}) {
  const ref = React.useRef<TurnstileInstance>();

  const turnstileWidgetSiteKey = import.meta.env.VITE_CLOUDFLARE_TURNSTILE_SITE_KEY;

  const onError = (error: any) => {
    onValidationChange?.(false);

    Sentry.captureException(new Error('Cloudflare Turnstile challenge failed'), {
      tags: {
        action: type,
        component: 'Cloudflare Turnstile',
      },
      extra: {
        turnstileError: error,
        timestamp: new Date().toISOString(),
      },
    });
  };

  const onSuccess = () => {
    onValidationChange?.(true);
  };

  const onExpire = () => {
    ref.current?.reset();
    onValidationChange?.(false);
  };

  return (
    <Turnstile
      ref={ref}
      siteKey={turnstileWidgetSiteKey}
      onError={(error) => onError(error)}
      onExpire={() => onExpire()}
      onSuccess={() => onSuccess()}
    />
  );
}
